<template>
    <!--
        message-list 的 @click 事件：
        用于修复 ios 弹出键盘时，点击消息列表区域无法让输入框失焦
        绑定事件后竟然生效！
     -->
    <div class="message-list"
        ref="messageList"
        :style="backgroundStyle"
        @click.prevent="blurTypingInput">
        <div class="message-list__scroll">
            <template
                v-for="item in messageList">
                <!-- S 时间 -->
                <message-time
                    v-if="item.name === MESSAGE_NAME.TIME"
                    :key="item.baseProps.id"
                    :baseProps="item.baseProps"
                    :content="item.content.text"></message-time>
                <!-- E 时间 -->

                <!-- todo: 补充所有事件 -->
                <!-- S 无操作，纯展示事件 -->
                <message-event
                    v-if="NO_ACTION_MESSAGE.includes(item.name)"
                    :key="item.baseProps.id"
                    :baseProps="item.baseProps"
                    :content="item.content.text">
                </message-event>
                <!-- E 无操作，纯展示事件 -->

                <!-- S socket -->
                <message-event
                    v-if="item.name === MESSAGE_NAME.EVENT_SOCKET"
                    :key="item.baseProps.id"
                    :baseProps="item.baseProps"
                    :content="item.content.text">
                    <template slot="suffix">
                        <i class="event__icon"
                            :class="{
                                'icon_loading rotate': item.content.status === STATUS.SENDING,
                                'icon_check': item.content.status === STATUS.SUCCESS,
                                'icon_close': item.content.status === STATUS.FAIL
                            }"></i>
                    </template>
                </message-event>
                <!-- E socket -->

                <!-- S 事件_正在排队 -->
                <message-event
                    v-if="item.name === MESSAGE_NAME.EVENT_QUEUE"
                    :key="item.baseProps.id"
                    :baseProps="item.baseProps"
                    :content="item.content.text">
                    <!-- <template slot="suffix">
                        <p class="no-queue"
                            :class="{
                                'is-disabled': !isInQueue || theLastEventQueueId !== item.baseProps.id
                            }"
                            @click="noQueue">放弃排队</p>
                    </template> -->
                </message-event>
                <!-- E 事件_正在排队 -->

                <!-- S 文本 -->
                <message
                    v-if="item.name === MESSAGE_NAME.TEXT"
                    :key="item.baseProps.id"
                    :name="item.name"
                    :chatTarget="chatTarget"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :robot="item.robot"
                    :server="item.server"
                    :copyContent="item.content.text"
                    :retryContent="item.content.text">
                    <message-content-text
                        :content="item.content.text"
                        :host="item.baseProps.host"
                        :server="item.server">
                    </message-content-text>
                </message>
                <!-- E 文本 -->

                <!-- S 图片 -->
                <message
                    v-if="item.name === MESSAGE_NAME.IMAGE"
                    :key="item.baseProps.id"
                    :name="item.name"
                    :chatTarget="chatTarget"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-image
                        :url="item.content.url"
                        :name="item.content.fileName">
                    </message-content-image>
                </message>
                <!-- E 图片 -->

                <!-- S audio -->
                <message
                    v-if="item.name === MESSAGE_NAME.AUDIO"
                    :key="item.baseProps.id"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <!-- user：wechat audio -->
                    <template v-if="item.baseProps.host === HOST.USER">
                        <message-content-audio
                            :media="item.content.media"
                            :messageId="item.baseProps.id">
                        </message-content-audio>
                    </template>
                    <!-- srvice：audioPlayer -->
                    <template v-else>
                        <message-content-audio-player
                            :media="item.content.media"
                            :messageId="item.baseProps.id">
                        </message-content-audio-player>
                    </template>
                </message>
                <!-- E audio -->

                <!-- S 语音消息的文本转义 -->
                <message
                    v-if="item.name === MESSAGE_NAME.AUDIO_TRANSLATION"
                    :key="item.baseProps.id"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :robot="item.robot"
                    :server="item.server"
                    :copyContent="item.content.text"
                    :retryContent="item.content.text">
                    <message-content-audio-translation
                        :content="item.content.text">
                    </message-content-audio-translation>
                </message>
                <!-- E 语音消息的文本转义 -->

                <!-- S video -->
                <message
                    v-if="item.name === MESSAGE_NAME.VIDEO"
                    :key="item.baseProps.id"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <!-- <message-content-video
                        :url="item.content.url">
                    </message-content-video> -->
                    <!-- video 统一为文件样式 -->
                    <message-content-file
                        :fileName="item.content.fileName"
                        :fileSize="item.content.fileSize"
                        :type="item.content.type"
                        :url="item.content.url"></message-content-file>
                </message>
                <!-- E video -->

                <!-- S 文件 -->
                <message
                    v-if="item.name === MESSAGE_NAME.FILE"
                    :key="item.baseProps.id"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-file
                        :fileName="item.content.fileName"
                        :fileSize="item.content.fileSize"
                        :type="item.content.type"
                        :url="item.content.url"></message-content-file>
                </message>
                <!-- E 文件 -->

                <!-- S rich_text -->
                <message
                    v-if="item.name === MESSAGE_NAME.RICH_TEXT"
                    :key="item.baseProps.id"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-rich-text
                        :url="item.content.url">
                    </message-content-rich-text>
                </message>
                <!-- E rich_text -->

                <!-- S html -->
                <message
                    v-if="item.name === MESSAGE_NAME.HTML"
                    :key="item.baseProps.id"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-html
                        :content="item.content.text"
                        :host="item.baseProps.host"
                        :server="item.server">
                    </message-content-html>
                </message>
                <!-- E html -->

                <!-- S render_text -->
                <message
                    v-if="item.name === MESSAGE_NAME.RENDER_TEXT"
                    :key="item.baseProps.id"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-render-text
                        :host="item.baseProps.host"
                        :text="item.content.text"></message-content-render-text>
                </message>
                <!-- E render_text -->

                <!-- S select -->
                <message
                    v-if="item.name === MESSAGE_NAME.SELECT"
                    :key="item.baseProps.id"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-select
                        :mode="item.content.mode"
                        :content="item.content.text">
                    </message-content-select>
                </message>
                <!-- E select -->

                <!-- S option_normal -->
                <message
                    v-if="item.name === MESSAGE_NAME.OPTION_NORMAL"
                    :key="item.baseProps.id"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-option-normal
                        :mode="item.content.mode"
                        :title="item.content.title"
                        :allNotText="item.content.allNotText"
                        :hasClickAllNot="item.robot ? item.robot.hasClickAllNot : undefined"
                        :options="item.content.options"
                        :messageId="item.baseProps.id"
                        :idFromServer="item.server.id">
                    </message-content-option-normal>
                </message>
                <!-- E option_normal -->

                <!-- S option_swiper -->
                <!-- 去掉该样式样式，统一为OPTION_NORMAL -->
                <!-- <message
                    v-if="item.name === MESSAGE_NAME.OPTION_SWIPER"
                    :key="item.baseProps.key"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-option-swiper
                        :options="item.content.options"
                        :allNotText="item.content.allNotText"
                        :hasClickAllNot="item.robot ? item.robot.hasClickAllNot : undefined"
                        :messageId="item.baseProps.id"
                        :idFromServer="item.server.id"></message-content-option-swiper>
                </message> -->
                <!-- E option_swiper -->

                <!-- S table -->
                <message
                    v-if="item.name === MESSAGE_NAME.TABLE"
                    :key="item.baseProps.id"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-table
                        :table="item.content.table" :server="item.server"></message-content-table>
                </message>
                <!-- E table -->

                <!-- S swiper_icon -->
                <message
                    v-if="item.name === MESSAGE_NAME.SWIPER_ICON"
                    :key="item.baseProps.key"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-swiper-icon
                        :swiperList="item.content.swiperList"></message-content-swiper-icon>
                </message>
                <!-- E swiper_icon -->

                <!-- S swiper_single -->
                <!-- 去掉固定轮播图卡片 -->
                <!-- <message
                    v-if="item.name === MESSAGE_NAME.SWIPER_SINGLE"
                    :key="item.baseProps.key"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-swiper-single
                        :swiperList="item.content.swiperList"
                        :options="item.content.options"></message-content-swiper-single>
                </message> -->
                <!-- E swiper_single -->

                <!-- S swiper_img_text -->
                <message
                    v-if="item.name === MESSAGE_NAME.SWIPER_IMG_TEXT"
                    :key="item.baseProps.key"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-swiper-img-text
                        :swiperList="item.content.swiperList"></message-content-swiper-img-text>
                </message>
                <!-- E swiper_img_text -->

                <!-- S swiper_list -->
                <message
                    v-if="item.name === MESSAGE_NAME.SWIPER_LIST"
                    :key="item.baseProps.key"
                    :chatTarget="chatTarget"
                    :name="item.name"
                    :baseProps="item.baseProps"
                    :layout="item.layout"
                    :server="item.server">
                    <message-content-swiper-list
                        :swiperList="item.content.swiperList"></message-content-swiper-list>
                </message>
                <!-- E swiper_list -->

                <!-- S 事件_消息发送失败 -->
                <message-event
                    v-if="item.baseProps.status === STATUS.FAIL"
                    :key="item.baseProps.id + '_fail'"
                    :baseProps="item.baseProps"
                    :content="getSendFailText(item.name)">
                    <template slot="prefix">
                        <icon name="send_fail" :width="14" :height="14" />
                    </template>
                </message-event>
                <!-- E 事件_消息发送失败 -->
            </template>

            <!-- S 正在录音 -->
            <message
                v-if="isVoiceRecording"
                :chatTarget="chatTarget"
                :name="MESSAGE_NAME.RECORDING"
                :baseProps="{
                    host: HOST.USER
                }"
                :layout="recordingLayout">
                <message-content-recording></message-content-recording>
            </message>
            <!-- E 正在录音 -->

            <!-- S 回复 loading -->
            <!-- <message
                v-if="isWaitResponse"
                :name="MESSAGE_NAME.RESPONSE_LOADING"
                :baseProps="{
                    host: HOST.SERVICE
                }"
                :layout="responseLoadingLayout">
                <message-content-loading></message-content-loading>
            </message> -->
            <!-- E 回复 loading -->
        </div>
    </div>
</template>

<script>
    import Viewer from 'viewerjs'
    import { Dialog } from 'vant'
    import Icon from '@/components/Icon'
    import Message from './components/Message'
    import MessageTime from './components/MessageTime'
    import MessageEvent from './components/MessageEvent'
    import MessageContentText from './components/MessageContentText'
    import MessageContentImage from './components/MessageContentImage'
    import MessageContentAudio from './components/MessageContentAudio'
    import MessageContentAudioTranslation from './components/MessageContentAudioTranslation'
    import MessageContentAudioPlayer from './components/MessageContentAudioPlayer'
    // import MessageContentVideo from './components/MessageContentVideo'
    import MessageContentFile from './components/MessageContentFile'
    import MessageContentRichText from './components/MessageContentRichText'
    import MessageContentHtml from './components/MessageContentHtml'
    import MessageContentSelect from './components/MessageContentSelect'
    import MessageContentTable from './components/MessageContentTable'
    import MessageContentRenderText from './components/MessageContentRenderText'
    import MessageContentOptionNormal from './components/MessageContentOptionNormal'
    // import MessageContentOptionSwiper from './components/MessageContentOptionSwiper'
    import MessageContentSwiperIcon from './components/MessageContentSwiperIcon'
    // import MessageContentSwiperSingle from './components/MessageContentSwiperSingle'
    import MessageContentSwiperImgText from './components/MessageContentSwiperImgText'
    import MessageContentSwiperList from './components/MessageContentSwiperList'
    import MessageContentRecording from './components/MessageContentRecording'
    //import MessageContentLoading from './components/MessageContentLoading'
    import {
        MESSAGE_NAME,
        STATUS,
        HOST,
        NO_ACTION_MESSAGE,
        CHAT_TARGET
    } from '@/constants/message'
    import {
        VIEWER_UPDATE,
        VIEWER_HIDE,
        VIEWER_SHOW,
        BLUR_TYPING_INPUT
    } from '@/constants/pub_sub'
    import { putNoQueue } from '@/api/chat'
    import { scrollTo, hasClass } from '@/utils/dom'
    // import DragScroll from '@/utils/drag_scroll'

    export default {
        name: 'TheMessageList',
        components: {
            Icon,
            Message,
            MessageTime,
            MessageEvent,
            MessageContentText,
            MessageContentImage,
            MessageContentAudio,
            MessageContentAudioTranslation,
            MessageContentAudioPlayer,
            // MessageContentVideo,
            MessageContentFile,
            MessageContentRichText,
            MessageContentHtml,
            MessageContentTable,
            MessageContentSelect,
            MessageContentRenderText,
            MessageContentOptionNormal,
            // MessageContentOptionSwiper,
            MessageContentSwiperIcon,
            // MessageContentSwiperSingle,
            MessageContentSwiperImgText,
            MessageContentSwiperList,
            //MessageContentLoading,
            MessageContentRecording
        },
        props: {
            messageList: {
                type: Array,
                required: true
            },
            isInQueue: {
                type: Boolean,
                required: true
            },
            theLastEventQueueId: {
                type: String,
                required: true
            },
            chatTarget: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                HOST,
                STATUS,
                MESSAGE_NAME,
                NO_ACTION_MESSAGE,
                // dragScroll: null,
                viewer: null
            }
        },
        computed: {
            isDesktop () {
                return this.$eventBus.isDesktop
            },
            isVoiceRecording () {
                return this.$eventBus.isVoiceRecording
            },
            isWaitResponse () {
                return this.$eventBus.isWaitResponse
            },
            lastMessage () {
                const messageListLength = this.messageList.length
                if (messageListLength === 0) {
                    return null
                }
                return this.messageList[messageListLength - 1]
            },
            recordingLayout () {
                if (this.lastMessage === null) {
                    return {
                        isShowHost: false,
                        isGroupStart: true,
                        isGroupEnd: true
                    }
                } else {
                    if (this.lastMessage.baseProps.host === HOST.USER) {
                        return {
                            isShowHost: false,
                            isGroupStart: false,
                            isGroupEnd: true
                        }
                    } else {
                        return {
                            isShowHost: false,
                            isGroupStart: true,
                            isGroupEnd: true
                        }
                    }
                }
            },
            responseLoadingLayout () {
                if (this.lastMessage === null) {
                    return {
                        isShowHost: true,
                        isGroupStart: true,
                        isGroupEnd: true
                    }
                } else {
                    if (this.lastMessage.baseProps.host === HOST.SERVICE) {
                        return {
                            isShowHost: false,
                            isGroupStart: false,
                            isGroupEnd: true
                        }
                    } else {
                        return {
                            isShowHost: true,
                            isGroupStart: true,
                            isGroupEnd: true
                        }
                    }
                }
            },
            theme () {
                return this.$eventBus.theme
            },
            backgroundStyle () {
                if (this.theme === 'white') {
                    return {
                        background: '#eeeeee'
                    }
                }
                return {
                    background: '#131313'
                }
            },
        },
        watch: {
            isVoiceRecording (value) {
                if (value) {
                    this.$nextTick(() => {
                        const $messageList = this.$refs.messageList
                        scrollTo($messageList, 0, 'scrollHeight')
                    })
                }
            }
        },
        methods: {
            blurTypingInput () {
                this.$eventBus.$emit(BLUR_TYPING_INPUT)
            },
            // 【放弃排队】 现在放入header组件中
            async noQueue () {
                if (!this.isInQueue) {
                    return
                }

                try {
                    await Dialog.confirm({
                        message: '确定放弃排队？'
                    })
                    // cancel 为 Promise.reject 不会执行下面一行，直接到 catch
                    confirm.call(this)
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                }

                async function confirm () {
                    try {
                        await putNoQueue(this.$eventBus.uid)
                        /**
                         * 退出排队成功，服务器会推 chat_notice 事件
                         * 但不会推 chat_status 事件
                         * 故需要前端主动切换
                         */
                        this.$emit('setChatHost', CHAT_TARGET.ROBOT)
                    } catch (err) {
                        // eslint-disable-next-line
                        console.error(err)
                        if (err.status !== 200) {
                            this.$emit('getChatHost')
                        }
                    }
                }
            },
            getSendFailText (messageName) {
                if (messageName === MESSAGE_NAME.AUDIO) {
                    return '语音识别失败，请尝试重新录音'
                } else {
                    return this.isDesktop
                        ? '该消息发送失败'
                        : '消息发送失败，长按消息即可重发'
                }
            },
            bindEvents () {
                this.$eventBus.$on(VIEWER_UPDATE, () => {
                    this.viewer && this.viewer.update()
                })

                this.$eventBus.$on(VIEWER_HIDE, () => {
                    this.viewer && this.viewer.hide()
                })

                this.$eventBus.$on(VIEWER_SHOW, (index) => {
                    if (this.viewer) {
                        this.viewer.show()
                        this.viewer.view(index) // 预览当前图片
                    }
                })
            },
            unbindEvents () {
                const events = [
                    VIEWER_UPDATE,
                    VIEWER_SHOW,
                    VIEWER_HIDE
                ]
                events.forEach(event => {
                    this.$eventBus.$off(event)
                })
            },
            viewerInit () {
                this.viewer = new Viewer(this.$refs.messageList, {
                    navbar: false,
                    title: false,
                    toolbar: this.isDesktop,
                    button: this.isDesktop,
                    tooltip: false,
                    scalable: false,
                    fullscreen: false,
                    loop: false,
                    backdrop: true,
                    show () {
                        this.viewer.update()
                    },
                    filter (image) {
                        return hasClass(image, 'viewer')
                    }
                })
            }
        },
        mounted () {
            /* if (this.isDesktop) {
                this.dragScroll = new DragScroll(this.$refs.messageList)
                this.dragScroll.init()
            } */
            this.bindEvents()

            // viewer初始化
            this.viewerInit()
        },
        beforeDestroy () {
            /* if (this.dragScroll) {
                this.dragScroll.destory()
            } */
            if (this.viewer) {
                this.viewer.destroy()
            }
            this.unbindEvents()
        }
    }
</script>

<style lang="scss" scoped>
    @import "./css/message_list";
</style>
